import {
  EOrderDealDirection,
  EOrderDealType,
  EOrderState,
  EOrderType,
  TOrderFillPolicy
} from '@webtrader/core/api/order';
import request from '@webtrader/core/request';

export enum EDealReason {
  CLIENT,
  EXPERT,
  DEALER,
  SL,
  TP,
  SO,
  ROLLOVER,
  EXTERNAL_CLIENT,
  VMARGIN,
  GATEWAY,
  SIGNAL,
  SETTLEMENT,
  TRANSFER,
  SYNC,
  EXTERNAL_SERVICE,
  MIGRATION,
  MOBILE,
  WEB,
  SPLIT
}

export interface IDealHistory {
  openTime: number;
  orderId: string;
  orderType: EOrderType;
  state: EOrderState;
  volume: number;
  volumeFilled: number;
  openPrice: number;
  takeProfit: number;
  stopLoss: number;
  symbol: string;
  lotSize: number;
  lotSizeFilled: number;
  fillPolicy: TOrderFillPolicy;
  deals: IDealDetail[];
  units: number;
  isEnable: boolean;
  decimal: number;
  closeTime: number;
  remarks: string;
}

export interface IDealDetail {
  comment: string;
  commission: number;
  dealId: number;
  dealType: EOrderDealType;
  direction: EOrderDealDirection;
  fee: number;
  openTime: number;
  price: number;
  profit: number;
  reason: EDealReason;
  stopLoss: number;
  swap: number;
  symbol: string;
  takeProfit: number;
  volume: number;
  lotSize: number;
  units: number;
}

export interface IDealHistoryParams {
  to: number;
  from: number;
}

const dealHistories = (params: IDealHistoryParams, signal?: AbortSignal) => {
  return request.get<IDealHistory[]>('/api/order/v1/deal/histories', {
    params,
    signal
  });
};

export default dealHistories;
